<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowDown } from "@mdi/js";
export default {
  name: "MdiAccount",
  data() {
    return {
      svgPath: mdiArrowDown,
    };
  },
};
</script>
